<template>
  <div class="search-drivers container-fluid r-aside">
    <loading :active.sync="isLoading"
             :can-cancel="true">
    </loading>
    <div class="row page-titles">
        <div class="col-md-5 align-self-center">
            <h3  v-if="driver" class="text-themecolor">{{ title }} for {{driver.name_first}} {{driver.name_last}}</h3>
        </div>
        <div class="col-md-7 align-self-center">
            <ol  v-if="driver" class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">{{ title }} for {{driver.name_first}} {{driver.name_last}}</li>
            </ol>
        </div>
    </div>
    <div v-if="balance!=null" class="row">
      <div class="col-md-6 col-lg-3">
        <div class="card" >
            <div class="card-body">
                <div class="row p-t-10 p-b-10">
                    <!-- Column -->
                    <div class="col p-r-0">
                        <h1 class="font-light">${{(balance).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</h1>
                        <h6 class="text-muted">Your balance</h6></div>
                    <!-- Column -->
                </div>
            </div>
        </div>
      </div>
    </div>
    <div v-if="balance!=null" class="row">
      <div class="col-md-12 col-lg-12">
        <div class="card" >
          <div class="card-body">
              <div class="d-flex">
                  <h4 class="card-title"><span class="lstick"></span>Ride and Transaction Dashboard</h4>
              </div>
          </div>
          <div class="card-body">

            <div class="row filter-inputs">
              <div class="col-md-4 col-lg-4 m-0 p-0">
                <div class="m-3">
                  <label class="search-label">Filter by Type</label>
                  <select type="text" placeholder="Market"
                          class="form-control down" v-on:change="changeType($event)">
                    <option value="">
                      All
                    </option>
                    <option v-for="(item) in types" :value="item.id">
                      {{titleCase(item.code.replace(/_/g, " "))}}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-3 col-lg-3 p-0">
                <div class="m-3 form-ddown">
                  <label class="search-label">Filter by Date</label>
                  <datetime type="datetime" v-model="min_date" input-class="form-control form-control-sm" placeholder="Min Date" label="Min Date" :noClearButton="false">
                  </datetime>
                  <font-awesome-icon v-if="min_date" @click="clearDate('min_date')" icon="times" style="color: red; cursor: pointer"/>
                </div>
              </div>

              <div class="col-md-3 col-lg-3 p-0">
                <div class="m-3 form-ddown">
                  <label class="search-label desktop-only" style="color: transparent;">Max Date</label>
                  <datetime type="datetime" v-model="max_date" label="Max Departure Date" input-class="form-control form-control-sm" placeholder="Max Date" >
                  </datetime>
                  <font-awesome-icon v-if="max_date" @click="clearDate('max_date')" icon="times" style="color: red; cursor: pointer"/>
                </div>
              </div>
            </div>
            <div class="row mobile-sort-input mobile-only">
              <div class="col-md-3 col-lg-3 p-0">
                <div class="m-3 form-ddown">
                  <label class="search-label">Sort By</label>
                  <select type="text" placeholder="Sort By" class="form-control down" v-on:change="mobile_sort($event)" ref="mobileSortField">
                    <option value="date_transaction">Transaction Date</option>
                    <option value="id_type_transaction">Transaction Type</option>
                    <option value="id_ride">Ride ID</option>
                    <option value="amount">Transaction Amount</option>
                  </select>
                </div>
              </div>

              <div class="col-md-3 col-lg-3 p-0">
                <div class="m-3 form-ddown">
                  <label class="search-label desktop-only" style="color: transparent;">Sort Direction</label>
                  <select type="text" placeholder="Sort By" class="form-control down" v-on:change="mobile_sort($event)"  ref="mobileSortDirection">
                    <option value="-1">Descending</option>
                    <option value="1">Ascending</option>
                  </select> 
                </div>
              </div>
            </div>
            <div class="result">
              <div class="">
                <div class="table-responsive">
                  <button @click="download()" class="btn btn-info waves-effect waves-light m-b-10" style="cursor: pointer; float:right;">Export</button>
                  <table class="table table-hover table-sm table-responsive-stack">
                    <tbody class="col-12">
                    <tr style="cursor: pointer" class="">
                      <th class="result-label" width="150px">
                        <div class=""  @click="sort('date_transaction')">
                          Date
                          <div class="arrow-down" ref="date_transaction" :name="'date_transaction'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label" width="10%">
                        <div class="" @click="sort('id_type_transaction')">
                        Type
                        <div class="arrow-down" ref="id_type_transaction" :name="'id_type_transaction'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label"  width="8%">Status</th>
                      <th class="result-label" width="8%">
                        <div class="" @click="sort('id_ride')">
                          Ride ID
                          <div class="arrow-down" ref="id_ride" :name="'id_ride'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div>
                      </th>
                      <th class="result-label" width="8%">
                        <div class=""  @click="sort('amount')">
                          Revenue
                          <div class="arrow-down" ref="amount" :name="'amount'" :value="1" style="visibility:hidden; margin-left: 5px;"></div>
                        </div></th>
                      <th class="result-label"  width="8%">Balance</th>
                      <th class="result-label">Comment</th>
                    </tr>

                    <template v-for="tran in data">
                      <tr>
                        <td class="result-item">
                          <span class="table-label">Date: </span>{{tran.date_transaction | moment("YYYY-MM-DD")}}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Type: </span>{{titleCase(tran.id_type_transaction.code.replace(/_/g, " "))}}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Status: </span>{{tran.id_type_transaction.id==1 ? (tran.date_processed ? 'Processed' : 'Scheduled') : 'N/A'}}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Ride ID: </span>{{ !tran.id_ride ? "N/A" : tran.id_ride.id_ride }}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Revenue: </span>{{ tran.id_type_transaction.id!=4 ? ('$' + (tran.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')) : 'N/A' }}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Balance: </span>${{tran.balance ? tran.balance.toFixed(2) : '0.00'}}
                        </td>
                        <td class="result-item">
                          <span class="table-label">Comment:<br> </span>{{ tran.comment ? (tran.other_payments ? ('unloaded' in tran.other_payments ? tran.comment + ' (plus unloaded payment $' + tran.other_payments['unloaded'] + ')' : tran.comment + ' (plus additional payment $' + tran.other_payments['additional'] + ')') : tran.comment) : 'N/A'}}
                          <button v-if="tran.id_type_transaction.id==2" @click="tran.show_details=!tran.show_details" class="btn btn-info waves-effect waves-light m-t-10 m-b-5">Details</button>
                        </td>
                      </tr>
                      <tr v-if="tran.id_ride && tran.show_details" class="transaction-details" style="text-align: left">
                        <td colspan="7">
                          <table class="table table-striped table-bordered table-hover table-condensed">
                            <tbody><tr>
                              <th colspan="2">Booking Information</th>
                            </tr>
                            <tr>
                              <td>Pickup Address</td>
                              <td>{{tran.id_ride.default_pickup_address}}</td>
                            </tr>
                            <tr>
                              <td>Dropoff Address</td>
                              <td>{{tran.id_ride.default_dropoff_address}}</td>
                            </tr>
                            <tr>
                              <td>Distance</td>
                              <td>{{(tran.id_ride.default_distance_p_to_d).toFixed(2)}} miles</td>
                            </tr>
                            <tr>
                              <td>Ride Duration</td>
                              <td>{{ (tran.id_ride.default_duration_p_to_d/60).toFixed(2) }} minutes</td>
                            </tr>
                            </tbody></table>
                          <!-- <table class="table table-striped table-bordered table-hover table-condensed">
                            <tbody><tr>
                              <th colspan="2">Payout Calculation</th>
                            </tr>
                            <tr>
                              <td>Gross Fare</td>
                              <td>${{(tran.id_ride.price_total).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</td>
                            </tr>
                            <tr>
                              <td colspan="2">General Platform Fees</td>
                            </tr>
                            <tr>
                              <td><span class="desktop-only-inline">&nbsp;&nbsp;- </span>Insurance Fee</td>
                              <td class="text-danger">$-{{tran.id_ride.price_insurance_fee?tran.id_ride.price_insurance_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : 0}}</td>
                            </tr>
                            <tr>
                              <td><span class="desktop-only-inline">&nbsp;&nbsp;- </span>Booking Fee</td>
                              <td class="text-danger">$-{{tran.id_ride.price_booking_fee?tran.id_ride.price_booking_fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'):0}}</td>
                            </tr>
                            <tr>
                              <th>Total Driver Payout</th>
                              <td class="text-bold" style="font-weight: bold">${{tran.id_ride.price_driver_revenue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}}</td>
                            </tr>
                            </tbody>
                          </table> -->
                        </td>
                      </tr>
                    </template>
                    <tr v-if="!data || data.length==0">
                      <td colspan="6">
                        No data available
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <div style="background-color: rgba(0, 0, 0, 0.05); float: left; width: 100%;">
                  <div style="margin: 1rem 1rem; float: left;">
                    <span v-if="totalRows > 0">Showing {{ perPage * (currentPage-1) + 1 }} to {{ perPage * currentPage > totalRows ? totalRows : perPage * currentPage }} of {{ totalRows }} entries</span>
                    <span v-else>Showing 0 entries</span>
                  </div>

                  <div style="margin: 0 1rem; float: right;">
                    <b-pagination style="margin: .5rem 0;" align="center" :total-rows=totalRows v-model="currentPage" :per-page=perPage :limit=limit @change="changePage">
                    </b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay'
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default {
    metaInfo: {
      title: 'Wingz Support | Driver Dashboard',
    },
    name: 'DriverDashboard',
    data () {
      return {
        title: 'Driver Dashboard',
        data: {},
        id_driver: null,
        driver: null,
        balance: 0,
        isLoading: false,
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
        limit: 10,
        with_deactivated: false,
        types: [],
        type_chose: null,
        prev_sort: null,
        min_date: null,
        max_date: null,
      }
    },
    components: {
      Loading
    },
    watch: {
      min_date: function(val) {
        console.log('min_date changed')
        console.log(val)
        this.search()
      },
      max_date: function(val) {
        console.log('max_date changed')
        console.log(val)
        this.search()
      }
    },
    methods: {
      sort(field) {
        console.log(field)
        let obj = this.$refs[field]
        if (this.prev_sort) {
          this.prev_sort.style.visibility = 'hidden'
        }

        let value = obj.getAttribute('value')
        console.log(obj.getAttribute('name'))
        obj.setAttribute('value', -value)
        console.log(obj.getAttribute('value'))

        obj.style.visibility = 'visible'
        obj.style.transform = "rotate("  + (value>0?0:1) * 180 +  "deg)"

        this.prev_sort = obj

        this.search()
      },
      mobile_sort(event) {
        console.log(event)
        console.log(this.prev_sort)

        console.log(this.$refs.mobileSortField.value)

        let obj = this.$refs[this.$refs.mobileSortField.value]
        obj.setAttribute('value', this.$refs.mobileSortDirection.value)
        // obj.setAttribute('value', event.target.value)

        this.prev_sort = obj
        this.search()

      },
      changeType(event) {
        console.log(event.target.value)
        this.type_chose = event.target.value

        this.search()
      },
      download: function() {
        this.isLoading = true
        this.$http({
          url: process.env.API_BASE_URL + 'download_driver_transaction/?id_user=' + this.id_driver
            + (this.type_chose ? '&id_type_transaction=' + this.type_chose : '')
            + '&min_date=' + (this.min_date ? this.min_date : '')
            + '&max_date=' + (this.max_date ? this.max_date : ''),
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'driver-dashboard-for-' + this.driver.name_first + '-' + this.driver.name_last + '.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
          this.isLoading = false
        });
      },
      getTypes: function () {
        this.$http
          .get(process.env.API_BASE_URL + 'type-transactions/')
          .then(response => {
            console.log(response.data)
            this.types = response.data
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => {

          })
      },
      getBalance: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_driver + '/?type=balance')
          .then(response => {
            console.log(response.data)
            this.balance = response.data.balance

            this.search()
            this.getTypes()
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {

          })
      },
      getUserInfo: function () {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'users/' + this.id_driver + '/')
          .then(response => {
            console.log(response.data)
            this.driver = response.data

            this.getBalance()
          })
          .catch(error => {
            console.log(error)
            this.isLoading = false
          })
          .finally(() => {

          })
      },
      search: function (page) {
        this.isLoading = true
        this.$http
          .get(process.env.API_BASE_URL + 'transactions/?to_id_user=' + this.id_driver
            + '&page=' + (page ? page : this.currentPage)
            + '&ordering=' + (this.prev_sort ? (this.prev_sort.getAttribute('value')>0 ? '' : '-') + this.prev_sort.getAttribute('name') : '')
            + (this.type_chose ? '&id_type_transaction=' + this.type_chose : '')
            + '&date_approved__gte=' + (this.min_date ? this.min_date : '')
            + '&date_approved__lte=' + (this.max_date ? this.max_date : '')
          ).then(response => {
            console.log(response.data)
            for (let index in response.data.results) {
              response.data.results[index]['show_details'] = false
            }
            this.data = response.data.results

            this.totalRows = 0
            if (response.data && response.data.count) {
              this.totalRows = response.data.count
            }
          })
          .catch(error => {
            console.log(error)
            this.errored = true
          })
          .finally(() => this.isLoading = false)
      },
      buttonSearch (page) {
        this.resetPager()
        this.search(page)
      },
      changePage: function (page) {
        console.log('change to page: ' + page)
        this.search(page)
      },
      resetPager: function () {
        this.currentPage = 1
        this.totalRows = 0
      },
      titleCase: function(str) {
        var splitStr = str.toLowerCase().split(' ');
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(' ');
      },
      clearDate(date) {
        if (date == 'min_date') {
          this.min_date = null
        }
        if (date == 'max_date') {
          this.max_date = null
        }
      },
    },
    mounted () {
      this.id_driver = this.getUser()['id_user']
      this.getUserInfo()
    },
    created () {
      // document.title = "Verida Support | Driver Dashboard";
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .submit-button {
    margin-top: 10px;
  }

  .result {
    margin-top: 20px;
  }
  .table td, .table th {
    vertical-align: middle;
    padding: .85rem;
  }

  .table td .btn {
    float: right;
    position: absolute;
    right: 25px;
    transform: translateY(-50%);
    padding: 3px 12px;
  }
  .table th > div {
    position: relative;
    display: inline;
  }
  .table th > div .arrow-down {
    position: absolute;
    right: -13px;
    top: 40%;
  }
  .table-hover tbody tr.transaction-details:hover {
    background-color: transparent;
  }
  .table-hover tbody tr.transaction-details tr:hover {
    background-color: transparent;
  }
  tr.transaction-details .table-striped tbody tr:nth-of-type(odd):hover {
    background-color: #e9edf2;
  }

  .table-responsive-stack .table-label {
    display: none;
  }

  .mobile-only {
    display: none;
  }
  .desktop-only {
      display: block;
  }
  .desktop-only-inline {
      display: inline;
  }

  @media screen and (max-width: 768px) {

    .table-responsive-stack .table-label {
      display: inline;
      font-weight: 600;
    }

    .table-responsive-stack tr th {
      display: none;
    }

    .table-responsive-stack tr {
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
            -ms-flex-direction: column;
                flex-direction: column;
        border-bottom: 1px solid #ccc;
        display:block;
        padding: 15px 0px;
    }
    .table-responsive-stack td {
        display:block;      
        padding: 0px;
        border-top: none;  
    }    
    .table-responsive-stack td .btn {
      position: relative;
      right: 0px;
      transform: translateY(-50%);
      -webkit-transform: translateY(-50%);
    }    

    .filter-inputs,
    .mobile-only {
      display: block;
    }
    .desktop-only-inline,
    .desktop-only {
      display: none;
    }

    .table-responsive-stack .transaction-details tr th {
      display: block;
    }
    .table-responsive-stack .transaction-details tr td {
      padding: 0.1rem 0.85rem;
      border-bottom: none;
    }    

    

    /*  IE9 FIX   */
    .table-responsive-stack td {
        float: left\9;
        width:100%;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/DriverDashboard.vue